<template>
  <Layout>
    <div class="bloco">
      <div class="cabecalho">
        <div class="row">
          <div class="col-md-11">
            <div class="titulo">Relatório Receitas - SIGEN+</div>
            <div class="subTitulo"
              >Gere aqui o arquivo de movimentação de Receituário - SIGEN+</div
            >
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="borda"></div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-2">
            <b-form-group id="input-group-1" label="Data Inicial">
              <date-picker
                id="input-2"
                v-model="estoqueRequest.data_inicial"
                :first-day-of-week="0"
                format="YYYY-MM-DD"
                value-type="format"
                lang="pt-br"
                placeholder="dd/mm/yyyy"
                :class="{
                  empty: isSubmit && estoqueRequest.data_inicial === '',
                }"
              ></date-picker>
            </b-form-group>
          </div>
          <div class="col-md-2">
            <b-form-group id="input-group-1" label="Data Final">
              <date-picker
                id="input-2"
                v-model="estoqueRequest.data_final"
                :first-day-of-week="0"
                format="YYYY-MM-DD"
                value-type="format"
                lang="pt-br"
                placeholder="dd/mm/yyyy"
                :class="{
                  empty: isSubmit && estoqueRequest.data_final === '',
                }"
              ></date-picker>
            </b-form-group>
          </div>
          <div class="col-md-4">
            <button class="btn btn-webreceita" @click="getCsv">Gerar</button>
          </div>
        </div>
      </div>
      <loading
        :active.sync="isLoading"
        color="#008e75"
        :can-cancel="true"
      ></loading>
    </div>
  </Layout>
</template>

<script>
import Layout from '@layouts/main'

import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import arquivo from '@/src/services/arquivo'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/locale/pt-br'
import 'vue2-datepicker/index.css'

export default {
  components: { Layout, Loading, DatePicker },
  data() {
    return {
      isLoading: false,
      estoqueRequest: {
        data_inicial: '',
        data_final: '',
      },
      isSubmit: false,
    }
  },
  watch: {
    estoqueRequest: {
      handler: function (val, oldVal) {
        this.isSubmit = false
      },
      deep: true,
    },
  },
  methods: {
    getCsv() {
      if (this.estoqueRequest.art !== '') {
        this.isLoading = true
        const token = this.$store.state.auth.currentUser.token
        arquivo
          .generateAndDownloadSP(token, this.estoqueRequest)
          .then((response) => {
            var hiddenElement = document.createElement('a')
            hiddenElement.href =
              'data:text/plain;charset=UTF-8,' +
              encodeURIComponent(response.data)
            hiddenElement.target = '_blank'
            hiddenElement.download = response.headers.file_name
            hiddenElement.click()
            URL.revokeObjectURL(hiddenElement.href)
            this.isLoading = false
          })
          .catch((err) => {
            this.isLoading = false
            this.$bvToast.toast(
              err.response.data.msg || 'Ecorreu um erro ao Criar Arquivo',
              {
                variant: 'danger',
                solid: false,
                noCloseButton: true,
                toaster: 'b-toaster-top-center',
              }
            )
          })
      } else {
        this.isSubmit = true
        this.$bvToast.toast('Preencha os campos de obrigatórios!', {
          variant: 'danger',
          solid: false,
          noCloseButton: true,
          toaster: 'b-toaster-top-center',
        })
      }
    },
  },
}
</script>

<style>
.empty {
  border: 1px solid red;
}
</style>